import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { CheckCircle2, XCircle, AlertTriangle } from 'lucide-react';
import { SupplierQualification } from '../../lib/api';
import { format } from 'date-fns';

interface ApprovalsTabProps {
  qualification: SupplierQualification;
}

export function ApprovalsTab({ qualification }: ApprovalsTabProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Approval History</CardTitle>
        <CardDescription>Record of all approval decisions</CardDescription>
      </CardHeader>
      <CardContent>
        {qualification.approvals && qualification.approvals.length > 0 ? (
          <div className="space-y-4">
            {qualification.approvals.map((approval) => (
              <div
                key={approval.id}
                className={`p-4 rounded-lg border ${
                  approval.decision === 'approved'
                    ? 'bg-green-50 border-green-200 dark:bg-green-950 dark:border-green-900'
                    : approval.decision === 'rejected'
                    ? 'bg-red-50 border-red-200 dark:bg-red-950 dark:border-red-900'
                    : 'bg-amber-50 border-amber-200 dark:bg-amber-950 dark:border-amber-900'
                }`}
              >
                <div className="flex items-start justify-between">
                  <div className="flex items-center gap-2">
                    {approval.decision === 'approved' && <CheckCircle2 className="h-5 w-5 text-green-600" />}
                    {approval.decision === 'rejected' && <XCircle className="h-5 w-5 text-red-600" />}
                    {approval.decision === 'more_info_required' && <AlertTriangle className="h-5 w-5 text-amber-600" />}
                    <span className="font-medium capitalize">{approval.decision?.replace(/_/g, ' ')}</span>
                  </div>
                  <span className="text-sm text-muted-foreground">
                    {format(new Date(approval.created_at), 'MMM d, yyyy h:mm a')}
                  </span>
                </div>
                <p className="text-sm mt-2">By {approval.approver_name}</p>
                {approval.comments && (
                  <p className="text-sm mt-2 text-muted-foreground">{approval.comments}</p>
                )}
              </div>
            ))}
          </div>
        ) : (
          <p className="text-muted-foreground text-center py-4">No approval decisions yet</p>
        )}
      </CardContent>
    </Card>
  );
}
